var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__ready",style:({ width: ((_vm.props.value) + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }